const initialState = {
  totalRincian: 0,
  hasilRincian: [],
  mataUangList: [{}],
  dataNoSeal: [{}],
  form: {},
  totalAmount: 0,
};

const serviceCashPickUpReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TOTAL_RINCIAN':
      return {
        ...state,
        totalRincian: action.payload,
      };
    case 'SET_HASIL_RINCIAN':
      return {
        ...state,
        hasilRincian: action.payload,
      };
    case 'SET_MATA_UANG_LIST':
      return {
        ...state,
        mataUangList: action.payload,
      };
    case 'ADD_DATA_NO_SEAL':
      return {
        ...state,
        dataNoSeal: action.payload,
      };
    case 'RESET_MATA_UANG_LIST':
      return {
        ...state,
        mataUangList: action.payload,
      };
    case 'RESET_ADD_DATA_NO_SEAL':
      return {
        ...state,
        dataNoSeal: action.payload,
      };
    case 'RESET_HASIL_RINCIAN':
      return {
        ...state,
        hasilRincian: action.payload,
      };
    case 'SET_FORM_UANG':
      return {
        ...state,
        form: action.payload,
      };
    case 'SET_TOTAL_AMOUNT':
      return {
        ...state,
        totalAmount: action.payload,
      };
    case 'RESET_TOTAL_AMOUNT':
      return {
        ...state,
        totalAmount: action.payload,
      };
    default:
      return state;
  }
};

export default serviceCashPickUpReducers;
